import { fmtMetric } from "@/lib/format";
import DeltaBadge from "@/components/DeltaBadge";

export default function Kpis({ headline }) {
  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-5" data-testid="kpi-row">
      {headline.map((h, i) => (
        <div
          key={h.key}
          data-testid={`kpi-${h.key}`}
          style={{ animationDelay: `${i * 70}ms` }}
          className="animate-fade-up rounded-2xl border border-border/60 bg-card p-5 shadow-sm transition-shadow hover:shadow-md"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.15em] text-muted-foreground">{h.label}</p>
          <p className="mt-2 font-heading text-3xl font-bold tracking-tight sm:text-4xl">{fmtMetric(h.value, h.format)}</p>
          <div className="mt-3 flex items-center gap-2">
            <DeltaBadge value={h.delta} />
            <span className="text-[11px] text-muted-foreground">vs prev</span>
          </div>
        </div>
      ))}
    </div>
  );
}
